<template>
  <v-card elevation="7" class="fixedBottom w-100" color="white">
    <v-flex d-flex justify-space-around>
      <v-icon class="my-3" :class="bottomNav == 'driver-vehicle-request' ? 'active' : 'noActive'" @click="route('/user/solicitar-reserva')">calendar_today</v-icon>
      <v-icon class="my-3" :class="bottomNav == 'driver-vehicle-request-dashboard' ? 'active' : 'noActive'" @click="route('/user/minhas-reservas')">update</v-icon>
      <v-icon class="my-3" :class="bottomNav == 'payment' ? 'active' : 'noActive'" @click="route('/user/pagamento')">account_balance_wallet</v-icon>
      <v-icon class="my-3" :class="bottomNav == 'usr-profile' ? 'active' : 'noActive'" @click="route('/user/perfil')">person</v-icon>
      <v-icon class="my-3" :class="bottomNav == 'help' ? 'active' : 'noActive'" @click="route('/user/ajuda')">help</v-icon>
    </v-flex>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      bottomNav: ""
    };
  },

  created(){
    this.bottomNav = this.$route.name
  },

  methods: {
    route(rota) {
      this.$router.push(rota)
    }
  }
};
</script>

<style scoped>
.active{
  color: var(--secondary-color) !important;
}

.noActive{
  color: rgb(161, 161, 161) !important;
}

.fixedBottom{
  z-index: 3;
  height: 56px;
  position: fixed;
  bottom: 0;
}
</style>